<table
  class="table-grid"
  *ngIf="grid.length && data.checkPermission ? data.editMode : true"
>
  <tbody>
    <tr *ngFor="let row of grid">
      <td *ngFor="let cell of row">
        {{ cell }}
      </td>
    </tr>
  </tbody>
</table>
